import React from 'react';
import UserLayout from '../Layout/UserLayout';
import PaymentInfo from '../StudentProfile/subComponents/PaymentInfo';

const Payment = () => {
    return (
        <UserLayout title="NỘP LỆ PHÍ">
            <PaymentInfo />
        </UserLayout>
    );
};

export default Payment;
